import backend from '@common/backend';

const BASE = '/parents';

export interface IGetParentsQuery {
	search?: string;
	page?: number;
	limit?: number;
}

const parentToBE = ({ students, ...parent }: any) => ({
	...parent,
	students_ids: students.map((student: any) => student.id),
});

export const getParents = async (query: IGetParentsQuery) => backend.get(`${BASE}/`, {
	params: query,
});

export const createParent = async (data: any) => backend.post(`${BASE}`, data);

export const getParent = async (id: number) => backend.get(`${BASE}/${id}`);

export const saveParent = async (id: number, data: any) => backend.post(`${BASE}/${id}`, parentToBE(data));
